import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AboutSection() {
  const [content, setContent] = useState({
    hero_title: 'A Hub for Thinkers, Visionaries and Leaders',
    hero_description: "The Circuit is where ambition meets momentum. We've created an environment where businesses don't just operate—they grow effortlessly.\n\nThis isn't about desks and meeting rooms. It's about precision, privacy, and performance. Every detail—from design to technology—is shaped to help decision-makers think clearly, act boldly, and build confidently.\n\nWhether you're a founder scaling fast or a CXO leading transformation, The Circuit gives you the space to focus on what matters.",
    hero_image_url: ''
  });

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/about-content`);
        // Convert relative URL to full URL for image
        const contentData = response.data;
        if (contentData.hero_image_url && !contentData.hero_image_url.startsWith('http')) {
          contentData.hero_image_url = `${API_URL}${contentData.hero_image_url}`;
        }
        setContent(contentData);
      } catch (error) {
        console.error('Error fetching about content:', error);
      }
    };
    fetchContent();
  }, []);

  // Split description into paragraphs
  const paragraphs = content.hero_description.split('\n\n').filter(p => p.trim());

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white" id="about" data-testid="about-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Image */}
          <div className="scroll-reveal order-2 lg:order-1" data-testid="about-image">
            <img
              src={content.hero_image_url || "https://images.unsplash.com/photo-1704655295066-681e61ecca6b?w=800&q=90"}
              alt="Executive Workspace"
              className="w-full h-[300px] sm:h-[400px] lg:h-[500px] object-cover rounded-lg shadow-lg"
            />
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#222] mb-4 sm:mb-6">
              {content.hero_title}
            </h2>
            <div className="space-y-3 sm:space-y-4 text-[#666] text-sm sm:text-base leading-relaxed">
              {paragraphs.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
            <Link to="/about" data-testid="about-know-more-button">
              <button className="btn-primary mt-4 sm:mt-6">Know More</button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}